#import "./BarMitzvahDetails.graphql"
query MyBarMitzvahQuery {
  myBarMitzvah {
    ...barMitzvahDetails
  }
}
